import { Link } from 'react-router-dom';
import { categoryCards } from '@/mocks/homeData';

export default function CategoryCards() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            热门<span className="text-primary-500">分类</span>
          </h2>
          <p className="text-foreground-500 text-sm mt-2">按你喜欢的口味，精准吃瓜</p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categoryCards.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group bg-background-50 rounded-2xl border border-secondary-200/60 p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${cat.lightColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-xl md:text-2xl ${cat.textColor}`}></i>
              </div>

              {/* Name & Count */}
              <div className="flex items-baseline justify-between mb-2">
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </h3>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{cat.count.toLocaleString()}条</span>
              </div>

              {/* Description */}
              <p className="text-foreground-500 text-sm leading-relaxed">
                {cat.description}
              </p>

              {/* Arrow */}
              <div className="mt-4 flex items-center text-foreground-300 text-xs group-hover:text-primary-500 transition-colors">
                <span>浏览全部</span>
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}